var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariedOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 67,
    viewBox: "0 0 69 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3475 7.43755L34.5613 1.41763L47.4732 7.42565L34.3988 13.62L21.3475 7.43755ZM19.056 27.2915L19.0539 11.7658L31.9457 17.8724V33.3875L19.056 27.2915ZM36.8597 17.8699L49.7493 11.7655V27.2962L36.8597 33.3859V17.8699ZM3.30959 37.0173L16.5193 31.6491L28.5954 37.3559L15.4475 43.5909L3.30959 37.0173ZM40.2097 37.3596L52.2101 31.6872L64.5434 37.518L52.224 43.0447L40.2097 37.3596ZM19.0561 47.2975L31.9457 41.1889V56.8133L19.0561 62.924V47.2975ZM36.8623 56.9443V41.1933L49.7518 47.2977V63.9127L36.8623 56.9443ZM1.25 56.9449V41.3998L14.1396 48.3808V63.9238L1.25 56.9449ZM54.6684 47.3386L66.8839 41.8607V57.512L54.6684 62.9962V47.3386Z",
    stroke: "#092E40",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariedOrganization);
export default __webpack_public_path__ + "static/media/varied-organization.f9b6505b3070e9389cd443c50f13a18a.svg";
export { ForwardRef as ReactComponent };